import React, { useState } from 'react';
import { Form, Row, Spin, Modal, Button, Space, Input, Select } from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { LoadingOutlined, SaveOutlined, PlusOutlined, FileSearchOutlined, CloseOutlined } from '@ant-design/icons';
import TextEditor from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  message,
  UploadImage,
  FormLabel,
  HelpMessage,
} from 'components/common';
import { postCartonLable, previewCartonLabel } from 'services/storeSetup';
import { nowTime } from 'utils';

interface AddServiceProps {
  visible: boolean;
  onHide: () => void;
  onRefresh: () => void;
  store: any;
  carton?: any;
  templates: any[];
}

// eslint-disable-next-line
export default (props: AddServiceProps) => {
  const { visible, onHide, onRefresh, templates, carton, store } = props;
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [form] = Form.useForm();

  const handleSubmit = async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;
    const postParams = {
      channelAccountCartonLabelNum: carton
        ? carton.channelAccountCartonLabelNum
        : 0,
      centralChannelNum: store?.centralChannelNum,
      channelAccountNum: store?.channelAccountNum,
      salesDivision: params.salesDivision,
      cartonLabelFooter: params.cartonLabelFooter,
      logo: params.logo,
      cartonLabelTemplateNum: params.cartonLabelTemplateNum,
      isPrintCartonLabel: params.isPrintCartonLabel ? 1 : 0,
    };
    try {
      setSubmitLoading(true);
      const res = await postCartonLable(postParams);
      setSubmitLoading(false);
      if (res.isSuccess) {
        message.success({
          content: carton ? 'Saved successfully' : 'Added successfully',
        });
        onRefresh();
        onHide();
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  const previewCarton = async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;
    const postParams = {
      ChannelAccountCartonLabelNum: carton
        ? carton.channelAccountCartonLabelNum
        : 0,
      ChannelAccountNum: store?.channelAccountNum,
      Footer: params.cartonLabelFooter,
      Logo: params.logo,
      CartonLabelTemplateNum: params.cartonLabelTemplateNum,
      Time: nowTime(),
    };
    try {
      setLoading(true);
      const res = await previewCartonLabel(postParams);
      setLoading(false);
      const w = window.open('about:blank');
      w?.document.write(res);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    const cancel = form.isFieldsTouched();
    if (!cancel) {
      onHide();
    } else {
      Modal.confirm({
        title: 'Leave / Refresh Page?',
        okText: 'Leave',
        cancelText: 'Cancel',
        content: `Changes you made may not be saved.`,
        onOk() {
          onHide();
        },
      });
    }
  };
  /* eslint-disable */
  //   useEffect(() => {
  //     if (insertItem) {}
  //   }, [insertItem]);
  /* eslint-enable */
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };
  return (
    <Modal
      title={`${carton ? 'Edit' : 'Add'} Carton Label Template`}
      centered
      visible={visible}
      maskClosable={false}
      width={900}
      destroyOnClose={true}
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            {false && <Button
              type="default"
              loading={loading}
              onClick={() => previewCarton()}
              icon={<FileSearchOutlined />}
            >
              Preview
            </Button>}
            <Button
              key="submit"
              type="primary"
              onClick={handleSubmit}
              loading={submitLoading}
              icon={carton ? <SaveOutlined /> : <PlusOutlined />}
            >
              {submitLoading
                ? `${carton ? 'Saving' : 'Adding'}`
                : `${carton ? 'Save' : 'Add'}`}
            </Button>
            <Button onClick={handleCancel} icon={<CloseOutlined />}>Cancel</Button>
          </Space>
        </Row>
      }
    >
      <Spin
        spinning={submitLoading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form {...layout} form={form}>
          <Form.Item
            name="salesDivision"
            initialValue={carton?.salesDivision}
            label={<FormLabel>Sales Division</FormLabel>}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="cartonLabelTemplateNum"
            initialValue={carton?.cartonLabelTemplateNum}
            label={<FormLabel>Carton Label Template</FormLabel>}
            rules={[
              { required: true, message: 'Carton Label Template is required' },
            ]}
          >
            <Select showSearch optionFilterProp="label">
              {templates.map((item) => (
                <Select.Option
                  value={item.printTemplateNum}
                  key={item.printTemplateNum}
                  label={item.templateName}
                >
                  {item.templateName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="cartonLabelFooter"
            initialValue={carton?.cartonLabelFooter || ''}
            label={
              <>
                <FormLabel noColon>Carton Label Footer</FormLabel>
                <HelpMessage helpId={2} />:
              </>
            }
          >
            {/* <Input.TextArea rows={3} /> */}
            <TextEditor theme="snow" style={{ minHeight: 200 }} />
          </Form.Item>
          <Form.Item
            name="logo"
            initialValue={carton?.logo}
            label={<FormLabel>Store Logo</FormLabel>}
          >
            {/* <Input readOnly={!edited} /> */}
            <UploadImage style={{ marginTop: 5, width: 180 }} />
          </Form.Item>
          <Form.Item
            name="isPrintCartonLabel"
            initialValue={carton ? carton.isPrintCartonLabel : true}
            valuePropName="checked"
            label={<FormLabel noColon> </FormLabel>}
          >
            <Checkbox>Print Carton Label</Checkbox>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};
